import { createBrowserRouter, redirect, type RouteObject } from 'react-router';

import { RootLayout } from './layouts/RootLayout';
import { EventLayout } from './layouts/EventLayout';
import { HomePage } from './pages/HomePage';
import { AgendaPage } from './pages/AgendaPage';
import { LogisticsPage } from './pages/LogisticsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { RouteErrorBoundary } from './components/error-boundaries/RouteErrorBoundary';
import { CURRENT_YEAR } from './data/events';

// Pages from the signed-in version of the site. Old links and bookmarks land
// on the current event's home page instead of a 404.
const RETIRED_PATHS = [
  'materials',
  'login',
  'request-access',
  'auth/callback',
  'account/mfa',
  'mfa/verify',
  'admin/*',
];

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      // Default to the current event.
      {
        index: true,
        loader: () => redirect(`/${CURRENT_YEAR}`),
      },

      // Year-scoped event pages. EventLayout validates :year and provides
      // the active event + theme to its children.
      {
        path: ':year',
        element: <EventLayout />,
        errorElement: <RouteErrorBoundary />,
        children: [
          { index: true, element: <HomePage /> },
          { path: 'agenda', element: <AgendaPage /> },
          { path: 'logistics', element: <LogisticsPage /> },
          {
            path: 'materials',
            loader: ({ params }) => redirect(`/${params.year}`),
          },
        ],
      },

      // Back-compat: old flat paths redirect into the current year.
      { path: 'agenda', loader: () => redirect(`/${CURRENT_YEAR}/agenda`) },
      {
        path: 'logistics',
        loader: () => redirect(`/${CURRENT_YEAR}/logistics`),
      },
      ...RETIRED_PATHS.map((path) => ({
        path,
        loader: () => redirect(`/${CURRENT_YEAR}`),
      })),

      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
